export const DEFAULT_MAX_SOURCES = 4;

/**
 * GAS channel that analytics events are fired on. `fabric-elements` is the
 * standard channel for smart-link / fabric-elements telemetry.
 */
export const LINK_LIST_ANALYTICS_CHANNEL = 'fabric-elements';

/** actionSubject for link list analytics events. */
export const LINK_LIST_ACTION_SUBJECT = 'knowledge-card-link-list';
